import { useLayoutStore } from "./app/layout";
import { useAuthStore } from "./api/auth";
import { useSignInStore } from "./api/signin";
import { useVehicleStore } from "./api/vehicle";
import { useApplicationStore }  from "./app/application";
import { useTableSettings } from "@/state/app/tableSettings";


import { createPinia } from "pinia";

const pinia = createPinia();
export default pinia;

export {
    useLayoutStore,
    useAuthStore,
    useSignInStore,
    useApplicationStore,
    useVehicleStore,
    useTableSettings
};
